/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/api-v2-client";
import type { VideoEditorCreateEditSocialPublishMutationRequest, VideoEditorCreateEditSocialPublishMutationResponse, VideoEditorCreateEditSocialPublishPathParams, VideoEditorCreateEditSocialPublish401, VideoEditorCreateEditSocialPublish403, VideoEditorCreateEditSocialPublish404 } from "../models/VideoEditorCreateEditSocialPublish";
import type { UseMutationOptions, UseMutationResult, QueryClient } from "@tanstack/react-query";
import { videoEditorCreateEditSocialPublish } from "../axios/videoEditorCreateEditSocialPublish";
import { mutationOptions, useMutation } from "@tanstack/react-query";

export const videoEditorCreateEditSocialPublishMutationKey = () => [{ url: '/video-editor/v1/edits/:id/social-publish' }] as const

export type VideoEditorCreateEditSocialPublishMutationKey = ReturnType<typeof videoEditorCreateEditSocialPublishMutationKey>

export function videoEditorCreateEditSocialPublishMutationOptions<TContext = unknown>(config: Partial<RequestConfig<VideoEditorCreateEditSocialPublishMutationRequest>> & { client?: Client } = {}) {

        const mutationKey = videoEditorCreateEditSocialPublishMutationKey()
        return mutationOptions<VideoEditorCreateEditSocialPublishMutationResponse, ResponseErrorConfig<VideoEditorCreateEditSocialPublish401 | VideoEditorCreateEditSocialPublish403 | VideoEditorCreateEditSocialPublish404>, {id: VideoEditorCreateEditSocialPublishPathParams["id"], data: VideoEditorCreateEditSocialPublishMutationRequest}, TContext>({
          mutationKey,
          mutationFn: async({ id, data }) => {
            return videoEditorCreateEditSocialPublish(id, data, config)
          },
        })

}

/**
 * @description Starts publishing the edit video to the given social connection.
 * You can call this while the video is still rendering:
 * - If the video is already ready, publishing starts right away.
 * - If not, the publish is created in a waiting state (`waitingForMedia: true`) and continues automatically once rendering finishes. If rendering fails, the publish is marked as failed.
 * Use the returned upload (and upload status endpoints) to follow progress. You do not need a playback URL from `GET .../render/video-url` before calling this.
 * @summary Publish an edit to a social connection (allowed before the video is ready)
 * {@link /video-editor/v1/edits/:id/social-publish}
 */
export function useVideoEditorCreateEditSocialPublish<TContext>(options: 
{
  mutation?: UseMutationOptions<VideoEditorCreateEditSocialPublishMutationResponse, ResponseErrorConfig<VideoEditorCreateEditSocialPublish401 | VideoEditorCreateEditSocialPublish403 | VideoEditorCreateEditSocialPublish404>, {id: VideoEditorCreateEditSocialPublishPathParams["id"], data: VideoEditorCreateEditSocialPublishMutationRequest}, TContext> & { client?: QueryClient },
  client?: Partial<RequestConfig<VideoEditorCreateEditSocialPublishMutationRequest>> & { client?: Client },
}
 = {}) {

          const { mutation = {}, client: config = {} } = options ?? {}
          const { client: queryClient, ...mutationOptions } = mutation;
          const mutationKey = mutationOptions.mutationKey ?? videoEditorCreateEditSocialPublishMutationKey()

          const baseOptions = videoEditorCreateEditSocialPublishMutationOptions(config) as UseMutationOptions<VideoEditorCreateEditSocialPublishMutationResponse, ResponseErrorConfig<VideoEditorCreateEditSocialPublish401 | VideoEditorCreateEditSocialPublish403 | VideoEditorCreateEditSocialPublish404>, {id: VideoEditorCreateEditSocialPublishPathParams["id"], data: VideoEditorCreateEditSocialPublishMutationRequest}, TContext>
          

          return useMutation<VideoEditorCreateEditSocialPublishMutationResponse, ResponseErrorConfig<VideoEditorCreateEditSocialPublish401 | VideoEditorCreateEditSocialPublish403 | VideoEditorCreateEditSocialPublish404>, {id: VideoEditorCreateEditSocialPublishPathParams["id"], data: VideoEditorCreateEditSocialPublishMutationRequest}, TContext>({
            ...baseOptions,
            mutationKey,
            ...mutationOptions,
          }, queryClient) as UseMutationResult<VideoEditorCreateEditSocialPublishMutationResponse, ResponseErrorConfig<VideoEditorCreateEditSocialPublish401 | VideoEditorCreateEditSocialPublish403 | VideoEditorCreateEditSocialPublish404>, {id: VideoEditorCreateEditSocialPublishPathParams["id"], data: VideoEditorCreateEditSocialPublishMutationRequest}, TContext>
      
}